import { Box, LinearProgress } from "@mui/material";

export function PageLoading() {
    return (
        <Box
            style={{
                position: "absolute",
                width: "100%",
                top: 0,
            }}
        >
            <LinearProgress color="secondary" />
        </Box>
    );
}
